'use client';

import { KeyTextField } from '@prismicio/client';
import { memo } from 'react';

import styles from './contentList.module.scss';

interface ContentListProps {
  type: 'bulleted' | 'numbered';
  content: KeyTextField;
}

const DELIMITER = ':::';

const ContentListComponent = ({ type, content }: ContentListProps) => {
  const list: string[] | undefined = content?.split(DELIMITER);
  return (
    list &&
    (type === 'numbered' ? (
      <ol className={styles.list}>
        {list.map((item, index) => (
          <li key={`${item} ${index}`}>{item}</li>
        ))}
      </ol>
    ) : (
      <ul className={`${styles.list} ${styles.bulleted}`}>
        {list.map((item, index) => (
          <li key={`${item} ${index}`}>{item}</li>
        ))}
      </ul>
    ))
  );
};

export const ContentList = memo(ContentListComponent);
